import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { TopButton } from 'components';
import { Header } from './header/Header';
import { Footer } from './footer/Footer';

export function Layout({ setRef, langList, selectedLang }) {
  const [scrollPosition, setScrollPosition] = useState(0);

  const scroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };

  useEffect(() => {
    window.addEventListener('scroll', scroll);
    return () => {
      window.removeEventListener('scroll', scroll);
    };
  }, []);

  return (
    langList && (
      <>
        <Header setRef={setRef} scrollPosition={scrollPosition} list={langList.nav} selectedLang={selectedLang} />
        <main>
          <Outlet />
        </main>
        <Footer list={langList.footer} navList={langList.nav} selectedLang={selectedLang} />
        {scrollPosition > 100 && <TopButton />}
      </>
    )
  );
}
